export default __webpack_public_path__ + "static/media/sl_logo.b0cc0906.png";